<script>
import VolumeDetails from "./volume-details";
import PagesList from "./pages-list";
import PageImage from "../pages/page-image";
import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {
    PageImage,
    PagesList,
    VolumeDetails,
  },
  props: {
    album: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      selectedVolume: this.album,
      displayedPages: null,
      pagesFields: [
        {key: "NumPageAlbum", sortable: true, label: '#'},
        {key: "image", sortable: false, label: 'Image'},
        {key: "date", sortable: true},
        {key: "address", sortable: true, label: 'Adresse'},
        {key: "actions", sortable: false, class: 'text-center'},
      ]
    };
  },
  mounted() {
    this.selectVolume(this.album);
  },
  methods: {
    async selectVolume(volume) {
      this.selectedVolume = volume;

      if (!volume.pages || volume.pages === '') {
        volume.pages = await this.getPagesForVolume(volume);
      }

      this.displayedPages = volume.pages;
    },
    async getPagesForVolume(volume) {
      return await api.get('pages', {
        page: 1,
        length: 300,
        sortBy: 'NumPageAlbum',
        sortDir: 'asc',
        albums: volume.id
      }).then(response => {
        return response.data.data;
      });
    },
    getImageFromNumPageAlbum(numPageAlbum) {
      let pageFound = null;

      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page) && this.album.pages[page].NumPageAlbum === numPageAlbum) {
          pageFound = this.album.pages[page];
          break;
        }
      }

      return pageFound;
    },
  }
};
</script>

<template>
  <div>
    <b-card no-body>
      <b-row no-gutters class="align-items-center">
        <b-col md="4">
          <page-image :page="getImageFromNumPageAlbum(album.thumbnails_album)"></page-image>
        </b-col>
        <b-col md="8">
          <b-card-body :title="album.titre" :sub-title="`# ${album.num_inventaire}`">
            <b-card-text>

            </b-card-text>
            <b-card-text>
              <i class='bx bx-photo-album'></i> <span>{{
                album.volumes.length + 1
              }} volume{{ album.volumes.length > 0 ? 's' : '' }}</span>
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <b-row no-gutters class="align-items-center">
      <b-col>
        <h4>{{ 'Volume' + (album.volumes.length > 0 ? 's' : '') }}</h4>
        <b-row>
          <b-col md="4" class="pe-0">
            <ul class="list-unstyled chat-list">
              <li
                  @click="selectVolume(album)"
                  :class="{ active: selectedVolume.id === album.id }"
              >
                <a role="button">
                  <div class="media-body">
                    <volume-details :album="album"></volume-details>
                  </div>
                </a>
              </li>
              <li
                  v-for="volume in album.volumes"
                  :key="volume.id"
                  @click="selectVolume(volume)"
                  :class="{ active: selectedVolume.id === volume.id }"
              >
                <a role="button">
                  <div class="media-body">
                    <volume-details :album="volume"></volume-details>
                  </div>
                </a>
              </li>
            </ul>
          </b-col>
          <b-col>
            <b-card no-body>
              <b-card-body
                  :title="`Pages du volume ${this.selectedVolume.nom_volume !== '' ? this.selectedVolume.nom_volume :this.selectedVolume.titre }`">
                <pages-list v-if="displayedPages" :pages="displayedPages" :fields="pagesFields"></pages-list>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
